<template>
    <tr valign="middle">
        <td>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-1">
                        <div id="productImages" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-if="product.images.length == 0" class="carousel-item active">
                                    <div class="d-block p-image-small"></div>
                                </div>
                                <div v-for="(image, index) in product.images" :key="index" :class="{ 'carousel-item': index == 0, 'carousel-item': index > 0 }">
                                    <img v-lazy="`/images/${image.id}`" class="d-block p-image-small" alt="{{ image.name }}">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-11">
                        <div class="row">
                            <div class="col-1">
                                <BrandDisplay :brand="product.brand" />
                            </div>
                            <div class="col-3 product-title">
                                <a :href="`${product.route_to_productdetail}`">{{ product.model_long_name }}</a>
                            </div>
                            <div class="col-3 product-attribute-texts">
                                <template v-for="text in product.attribute_texts">
                                    <span>{{ text }}</span>
                                </template>
                            </div>
                            <div class="col-1">

                            </div>
                            <div class="col-2">
                                <div class="price-stock-container">
                                    <div class="price">{{ numberFormat(product.prices.lowest_price_including_shipping) }}</div>
                                    <div class="retailers">
                                        <span class="badge rounded-pill bg-secondary">
                                            <font-awesome-icon icon="fa-solid fa-cart-shopping" v-tooltip="`Priser fra ${product.prices.total_retailers} forhandler(e)`" /> {{ product.prices.total_retailers }}
                                        </span>
                                    </div>
                                    <div class="stock">
                                        <p v-if="product.prices.lowest_price_has_in_stock == true">
                                            <template v-if="product.prices.others_has_in_stock == true">
                                                <font-awesome-icon  v-tooltip="`På lager hos flere forhandlere`" icon="fa-solid fa-circle-check" class="yesyes" />&nbsp;<span class="yesyes">På lager</span>
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon v-tooltip="`På lager hos forhandler med laveste pris`" icon="fa-regular fa-circle-check" class="yes" />&nbsp;<span class="yesyes">På lager</span>
                                            </template>
                                        </p>
                                        <p v-else>
                                            <template v-if="product.prices.others_has_in_stock == true">
                                                <font-awesome-icon v-tooltip="`På lager hos andre end forhandler med laveste pris`" icon="fa-solid fa-circle-xmark" class="maybe" />&nbsp;<span class="maybe">På lager</span>
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon icon="fa-solid fa-circle-xmark" v-tooltip="`Ikke på lager hos nogle forhandlere`" class="no" />&nbsp;<span class="no">Ikke på lager</span>
                                            </template>
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                            <!--<div class="col-1">
                                <font-awesome-icon icon="fa-solid fa-star" />
                                {{ product.rating }}
                            </div>-->
                            <div class="col-2 text-end">
                                <a :href="`${product.route_to_productdetail}`" class="btn btn-pricecompare-primary">Gå til produkt</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import BrandDisplay from '@/Components/Product/BrandDisplay.vue';

export default {
    name: 'TableViewProduct',
    components: {
        BrandDisplay
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        numberFormat(value) {
            //convert to num first
            value = Number(value);

            //use intl
            return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
        }
    }
}
</script>

<style scoped>
.price-stock-container {
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end
}

.price-stock-container .price {
    font-size: 1rem;
    color: #1E3A8A;
    display: initial;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
}

.price-stock-container .retailers {
    font-size: 1rem;
}

.price-stock-container .stock {
    font-size: 0.8rem;
}

.p-image-small {
    width: 100px;
}

.yes {
    color: green;
}

.yesyes {
    color: darkgreen;
}

.no {
    color: red;
}

.maybe {
    color: yellow;
}

.product-attribute-texts {
    font-size: 0.8em;
    color: #6c757d;
    text-align: center;
}   

.product-title {
    font-weight: bold;
    font-size: 0.9em;
    text-align: left;
}

.product-title a {
    color: #333;
    text-decoration: none;
}

.product-attribute-texts span::after {
    content: '|';
    padding: 0 5px;
}

.product-attribute-texts span:last-child::after {
    content: '';
}

@media (max-width: 767.98px) {
    .container-fluid {
        padding: 0;
    }

    .row {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 15px; /* Add spacing between product cards */
    }

    .col-md-1, .col-md-11 {
        width: 100%;
    }

    .col-1, .col-3, .col-2 {
        width: 100%;
        margin-bottom: 10px;
    }

    .product-title {
        text-align: left;
        font-size: 1rem;
    }

    .product-attribute-texts {
        text-align: left;
        font-size: 0.9rem;
    }

    .price-stock-container {
        align-items: flex-start;
        text-align: left;
    }

    .price-stock-container .price {
        font-size: 1.2rem;
    }

    .price-stock-container .retailers {
        font-size: 1rem;
    }

    .price-stock-container .stock {
        font-size: 0.9rem;
    }

    .text-end {
        text-align: left !important;
    }

    .btn {
        width: 100%;
    }

    .retailer-info-collapse {
        display: block !important; /* Ensure the collapse/expand is visible */
    }

    .retailer-info-toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 10px;
        background-color: #f8f9fa;
        border: 1px solid #eaeaea;
        border-radius: 5px;
        margin-bottom: 10px;
        font-size: 1rem;
    }

    .retailer-info-toggle i {
        font-size: 1.5rem;
        color: #1E3A8A;
    }

    .retailer-info-toggle span {
        flex-grow: 1;
        text-align: left;
        color: #1E3A8A;
        font-weight: bold;
    }

    .retailer-info-content {
        padding: 10px;
        border: 1px solid #eaeaea;
        border-radius: 5px;
        margin-top: -1px;
        background-color: #ffffff;
    }

    .carousel-inner {
        display: flex;
        justify-content: center; /* Center product images */
    }
}
</style>